/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface CheckboxProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const Checkbox: React.FC<CheckboxProps> = ({size, ...props}) => (
  <svg viewBox="0 0 20 20" fill="currentColor" width={ size || "20" } height={ size || "20" } {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M1.82141 4.57141C1.82141 3.05263 3.05263 1.82141 4.57141 1.82141H15.4286C16.9473 1.82141 18.1786 3.05263 18.1786 4.57141V15.4286C18.1786 16.9473 16.9473 18.1786 15.4286 18.1786H4.57141C3.05263 18.1786 1.82141 16.9473 1.82141 15.4286V4.57141ZM4.57141 3.32141C3.88105 3.32141 3.32141 3.88105 3.32141 4.57141V15.4286C3.32141 16.1189 3.88106 16.6786 4.57141 16.6786H15.4286C16.1189 16.6786 16.6786 16.1189 16.6786 15.4286V4.57141C16.6786 3.88106 16.1189 3.32141 15.4286 3.32141H4.57141Z"
      />
      <path d="M14.6944 7.04273C14.986 7.33691 14.9839 7.81178 14.6897 8.10338L9.5215 13.226C9.38659 13.3594 9.22392 13.4628 9.04573 13.528C8.86753 13.5932 8.67739 13.6193 8.48823 13.6044C8.29906 13.5895 8.11532 13.5341 7.94949 13.4419C7.78371 13.3497 7.63972 13.2229 7.52731 13.0701C7.52728 13.0701 7.52735 13.0702 7.52731 13.0701L5.75101 10.6561C5.50551 10.3225 5.57696 9.85302 5.91058 9.60752C6.24421 9.36203 6.71367 9.43347 6.95917 9.7671L8.61294 12.0146L13.6338 7.03803C13.928 6.74643 14.4028 6.74854 14.6944 7.04273Z"
      />
    </g>
  </svg>
);
Checkbox.displayName = 'Checkbox';
export default Checkbox;
/* tslint:enable */
/* eslint-enable */
